var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"map-holder mt-6"},[_c('LMap',{staticClass:"map",attrs:{"zoom":_vm.zoom,"center":_vm.center}},[_c('LTileLayer',{attrs:{"url":_vm.url}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }